import { createBrowserRouter } from 'react-router'

import {
    isChromakeyModeActive,
    isMockActive,
    isMockPlayerDisabled,
    getTranscriptJobId,
    getTranscriptionDocumentId,
    getViewMode,
} from 'src/utils/env'
import { MetadataProvider } from 'src/contexts/Transcript/MetadataContext'
import { OrderDetailsProvider } from 'src/contexts/OrderDetailsContext'
import { LanguageProvider } from 'src/contexts/LanguageContext'
import { FeatureFlagProvider } from 'src/contexts/FeatureFlagContext'
import { TranscriptProvider } from 'src/contexts/Transcript/TranscriptContext'
import { VerbitConnectWrapperProvider } from 'src/contexts/VerbitConnectWrapperContext'
import { EditorProvider } from 'src/contexts/EditorContext'
import { ThemeProvider } from 'src/contexts/ThemeContext'
import { FerretSearchWrapperProvider } from 'src/contexts/FerretSearchWrapperProvider'
import { ClipboardProvider } from 'src/contexts/ClipboardContext'

import App from './App/App'
import { AppHelmet } from './App/AppHelmet'
import { MockControls } from './MockControls/MockControls'
import { RoutingError } from './RoutingError/RoutingError'

const viewMode = getViewMode()
const eventId = getTranscriptJobId()
const transcriptionDocumentId = getTranscriptionDocumentId()
const shouldDisplayMockControls = isMockActive() && !isChromakeyModeActive && !isMockPlayerDisabled() && viewMode === 'job'

export const router = createBrowserRouter([
    {
        path: '/',
        element: (
            <MetadataProvider viewMode={viewMode} transcriptionDocumentId={transcriptionDocumentId} eventId={eventId}>
                <LanguageProvider>
                    <FeatureFlagProvider>
                        <OrderDetailsProvider>
                            <TranscriptProvider eventId={eventId}>
                                <ThemeProvider>
                                    <VerbitConnectWrapperProvider>
                                        <EditorProvider>
                                            <FerretSearchWrapperProvider>
                                                <ClipboardProvider>
                                                    <AppHelmet />
                                                    <App />
                                                    {shouldDisplayMockControls && <MockControls />}
                                                </ClipboardProvider>
                                            </FerretSearchWrapperProvider>
                                        </EditorProvider>
                                    </VerbitConnectWrapperProvider>
                                </ThemeProvider>
                            </TranscriptProvider>
                        </OrderDetailsProvider>
                    </FeatureFlagProvider>
                </LanguageProvider>
            </MetadataProvider>
        ),
        errorElement: <RoutingError />,
    },
])
